import request from '@/utils/request'

let Maintenance_serviceApi = {

  /*检修服务列表*/
  list(data) {
    return request._post('/shop/plus.maintenance_service.Index/index', data);
},
/*添加检修服务*/
add(data) {
    return request._post('/shop/plus.maintenance_service.Index/add', data);
},
/*修改检修服务*/
edit(data) {
    return request._post('/shop/plus.maintenance_service.Index/edit', data);
},
/*删除检修服务*/
del(data) {
    return request._post('/shop/plus.maintenance_service.Index/del', data);
},
/*检修服务详情*/
detail(data) {
  return request._post('/shop/plus.maintenance_service.Index/detail', data);
},
/*申请记录*/
getApplyList(data) {
  return request._post('/shop/plus.maintenance_service.Index/getApplyList', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.maintenance_service.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.maintenance_service.Setting/getSetting', data, errorback);
    },
}
export default Maintenance_serviceApi;



// WEBPACK FOOTER //
// ./src/api/maintenance_service.js